
export { partnerApi } from "/home/runner/work/capsicum/capsicum/libs/common/services/index.ts"